<template>
  <div class="page">
    <div class="form" v-if="isShowSearch">
      <el-form
        :inline="true"
        :model="form"
        :rules="formRules"
        ref="formRef"
        size="small"
      >
        <slot name="tableSearch"></slot>
        <div class="item_button">
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button :loading="loading" type="primary" @click="onReset"
              >重置</el-button
            >
          </el-form-item>
        </div>

        <slot name="buttonArea"></slot>
      </el-form>

      <div><slot name="pageHeader"></slot></div>
    </div>
    <div class="child">
      <el-table
        :data="list"
        v-loading="loading"
        :row-style="{ height: '40px' }"
        :cell-style="{ padding: '2px 0' }"
        @sort-change="sortChange"
        :default-sort="sortInfo"
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <slot name="tableColumn"></slot>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[30, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page',
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      sort: 1,
      total: 0,
      loading: false,
    }
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    sortInfo: {
      type: Object,
      default: () => {},
    },
    form: {
      type: Object,
      default: null,
    },
    isShowSearch: {
      type: Boolean,
      default: true,
    },
    formRules: {
      type: Object,
      default: null,
    },
    axiosType:{
      type:String,
      default:''
    }
  },
  activated() {
    if (this.$store.state.isKeepLive && !this.$route.query.orderId) {
      this.list = []
      this.currentPage = 1
      this.pageSize = 30
      this.tableChang(this.form)
    }
    if (this.$route.query.orderId) {
      this.list = []
      this.currentPage = 1
      this.pageSize = 30
      this.form.orderId = this.$route.query.orderId
      this.tableChang(this.form)
    }
  },
  methods: {
    //修改每页条数触发
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.tableChang(this.form)
    },
    //翻页触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.tableChang(this.form)
    },
    //更新table数据
    tableChang(params) {
      let param = {}
      this.loading = true
      for (let key in params) {
        let value = params[key]
        if (value !== '' && value !== null) {
          param[key] = value
        }
      }

      param.size = this.pageSize
      param.page = this.currentPage
      if(this.axiosType=='post'){
        this.$axios
        .post(this.url,param)
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.total = parseInt(res.data.total)
            this.list = res.data.list
          }
        })
        .catch(() => {
          this.loading = false
        })
      }else{
        this.$axios
        .get(this.url, { params: param })
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.total = parseInt(res.data.total)
            this.list = res.data.list
          }
        })
        .catch(() => {
          this.loading = false
        })
      }
      
    },
    handleSelectionChange(val) {
      this.$emit('select-data', val)
    },
    refresh() {
      this.tableChang(this.form)
    },
    onSubmit() {
      this.currentPage = 1
      this.tableChang(this.form)
      //如果父组件里有统计方法，则执行统计
      if (this.$parent.countAmount) {
        this.$parent.countAmount()
      }
    },
    onReset() {
      Object.keys(this.form).forEach(key => {
        this.form[key] = ''
      })
      this.form.sortType = '00'
      this.$refs['formRef'].resetFields()
      this.$emit('reset')
      this.onSubmit()
    },
    sortChange(column) {
      let params = {
        ...this.form,
        sortType: column.order == 'ascending' ? '01' : '00',
      }
      this.tableChang(params)
    },
  },
  created() {
    // this.currentPage = 1
    // this.pageSize = 30
    // this.tableChang(this.form)
  },
  mounted() {
    this.$bus.$on('refresh', () => {
      this.tableChang(this.form)
    })
  },
}
</script>

<style scoped>
.page {
  background: transparent;
  text-align: left;
  border: 1px solid #dce4ea;
}

.form {
  border-bottom: 1px solid #dce4ea;
  padding: 10px;
  background-color: #ffffff;
}
.item_button {
  display: initial;
}
</style>